module.exports = __webpack_public_path__ + "img/sign-63.5efdf201.jpg";